import { SET_CURRENT_USER, SET_LANG, SET_META_DATA, UPDATE_CURRENT_USER, SET_USER_REQUEST, SET_USER_NOTIFICATION } from "./user.type"



export const setCurrentUser = user => ({
    type : SET_CURRENT_USER,
    payload : user
})

export const setUserRequest = user => ({
    type : SET_USER_REQUEST,
    payload : user
})

export const setNotificationList = list => ({
    type : SET_USER_NOTIFICATION,
    payload : list
})

export const updateCurrentUser = data => ({
    type : UPDATE_CURRENT_USER,
    payload : data
})

export const setCurrentLang = lang => ({
    type : SET_LANG,
    payload : lang
})

export const setMetaData = data => ({
    type : SET_META_DATA,
    payload : data
})